import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BarFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M19.5002 2.1001H15.3602L12.9006 6.71186L3.87927 6.71186L11.1002 15.0649V19.3501H8.34673V21.1501L15.7129 21.1501V19.3501H12.9002V15.1339L20.1807 6.71185L14.9406 6.71186L16.4402 3.9001H19.5002V2.1001Z"
      />
    </SvgIcon>
  );
});
